export enum CellularGeneration {
  UNKNOWN = 0,
  CELLULAR_2G = 1,
  CELLULAR_3G = 2,
  CELLULAR_4G = 3,
}
